export default function OduWithdrawal() {
    const $ = jQuery;

    let $modal   = null;
    let $confirm = null;
    let $cancel  = null;
    let $result  = null;
    let $actions = null;
    let currentData = null;

    $(function () {
        $modal   = $('#odu-modal');
        $confirm = $('#odu-confirm');
        $cancel  = $('#odu-cancel');
        $result  = $('#odu-result');
        $actions = $('#odu-actions');

        if (!$modal.length) return;

        bindEvents();

        if (window.ODU_AUTO_DATA) {
            openModal(window.ODU_AUTO_DATA);
        }
    });

    function bindEvents() {
        $(document).on('click', '.odu-trigger', function (e) {
            e.preventDefault();
            const raw = $(this).data('odu');
            const data = (typeof raw === 'string') ? JSON.parse(raw) : raw;
            openModal(data);
        });

        $modal.on('click', '.modal__close', () => closeModal());
        $modal.on('click', (e) => { if ($(e.target).is($modal)) closeModal(); });
        $cancel.on('click', () => closeModal());
        $(document).on('keydown.odu', (e) => { if (e.key === 'Escape') closeModal(); });
        $confirm.on('click', () => submitWithdrawal());
    }

    function openModal(data) {
        currentData = data;

        $('#odu-v-number').text('#' + data.number);
        $('#odu-v-date').text(data.date);
        $('#odu-v-total').text(data.total);
        $('#odu-v-items').html('<ul>' + data.items.map(i => `<li>${i}</li>`).join('') + '</ul>');

        const now = new Date();
        $('#odu-v-today').text(now.toLocaleDateString('pl-PL') + ' ' + now.toLocaleTimeString('pl-PL'));

        $result.hide().empty().removeClass('odu-result--ok odu-result--err');
        $actions.show();
        $confirm.prop('disabled', false).text('Potwierdź odstąpienie od umowy');

        $modal.removeClass('hidden').addClass('flex').attr('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
        $confirm.trigger('focus');
    }

    function closeModal() {
        if (!$modal || !$modal.hasClass('flex')) return;
        $modal.addClass('hidden').removeClass('flex').attr('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
        currentData = null;
    }

    function submitWithdrawal() {
        if (!currentData || !window.ODU_CONFIG) return;

        $confirm.prop('disabled', true).text('Wysyłanie…');
        $result.hide().removeClass('odu-result--ok odu-result--err');

        $.ajax({
            url:    ODU_CONFIG.ajax_url,
            method: 'POST',
            data: {
                action:    'odu_withdraw',
                nonce:     ODU_CONFIG.nonce,
                order_id:  currentData.order_id,
                order_key: currentData.order_key,
                token:     currentData.token,
            },
            success(r) {
                if (r.success) {
                    $actions.hide();
                    $result.addClass('odu-result--ok').html(`<p>${r.data.message}</p>`).show();
                    setTimeout(() => { window.location.href = r.data.redirect; }, 2000);
                } else {
                    $confirm.prop('disabled', false).text('Potwierdź odstąpienie od umowy');
                    $result.addClass('odu-result--err').html(`<p>${r.data.msg || 'Wystąpił błąd. Spróbuj ponownie.'}</p>`).show();
                }
            },
            error() {
                $confirm.prop('disabled', false).text('Potwierdź odstąpienie od umowy');
                $result.addClass('odu-result--err').html('<p>Błąd połączenia. Odśwież stronę i spróbuj ponownie.</p>').show();
            },
        });
    }
}

